<template>
    <div class="widget-component" v-if="renderPage">
        <v-container class="container-width widget-videos">
            <v-row
                v-if="
                    normalizedOptions.title.show || normalizedOptions.intro.show
                "
            >
                <v-col cols="12" v-if="normalizedOptions.title.show">
                    <h2 :class="normalizedOptions.title.classes">
                        {{ normalizedOptions.title.text }}
                    </h2>
                </v-col>
                <!-- <v-col cols="12" v-if="normalizedOptions.intro.show">
                    <div :class="normalizedOptions.intro.classes" :style="normalizedOptions.intro.style" v-html="normalizedOptions.intro.textHtml"></div>
                </v-col> -->
            </v-row>
        </v-container>

        <v-container class="widget-videos mt-5 mb-10 container-width">
            <v-row v-if="normalizedOptions.sliderType == 'slick'">
                <VueSlickCarousel
                    :accessibility="
                        normalizedOptions.slickOptions.accessibility
                    "
                    :adaptiveHeight:="
                        normalizedOptions.slickOptions.adaptiveHeight
                    "
                    :arrows="normalizedOptions.slickOptions.arrows"
                    :asNavFor="normalizedOptions.slickOptions.asNavFor"
                    :autoplay="normalizedOptions.slickOptions.autoplay"
                    :autoplaySpeed="
                        normalizedOptions.slickOptions.autoplaySpeed
                    "
                    :centerMode="normalizedOptions.slickOptions.centerMode"
                    :centerPadding="
                        normalizedOptions.slickOptions.centerPadding
                    "
                    :cssEase="normalizedOptions.slickOptions.cssEase"
                    :dots="normalizedOptions.slickOptions.dots"
                    :dotsClass="normalizedOptions.slickOptions.dotsClass"
                    :draggable="normalizedOptions.slickOptions.draggable"
                    :edgeFriction="normalizedOptions.slickOptions.edgeFriction"
                    :fade="normalizedOptions.slickOptions.fade"
                    :focusOnSelect="
                        normalizedOptions.slickOptions.focusOnSelect
                    "
                    :infinite="normalizedOptions.slickOptions.infinite"
                    :initialSlide="normalizedOptions.slickOptions.initialSlide"
                    :lazyLoad="normalizedOptions.slickOptions.lazyLoad"
                    :pauseOnDotsHover="
                        normalizedOptions.slickOptions.pauseOnDotsHover
                    "
                    :pauseOnFocus="normalizedOptions.slickOptions.pauseOnFocus"
                    :pauseOnHover="normalizedOptions.slickOptions.pauseOnHover"
                    :responsive="normalizedOptions.slickOptions.responsive"
                    :rows="normalizedOptions.slickOptions.rows"
                    :rtl="normalizedOptions.slickOptions.rtl"
                    :slidesPerRow="normalizedOptions.slickOptions.slidesPerRow"
                    :slidesToScroll="
                        normalizedOptions.slickOptions.slidesToScroll
                    "
                    :slidesToShow="normalizedOptions.slickOptions.slidesToShow"
                    :speed="normalizedOptions.slickOptions.speed"
                    :swipe="normalizedOptions.slickOptions.swipe"
                    :swipeToSlide="normalizedOptions.slickOptions.swipeToSlide"
                    :touchMove="normalizedOptions.slickOptions.touchMove"
                    :touchThreshold="
                        normalizedOptions.slickOptions.touchThreshold
                    "
                    :useCSS="normalizedOptions.slickOptions.useCSS"
                    :useTransform="normalizedOptions.slickOptions.useTransform"
                    :variableWidth="
                        normalizedOptions.slickOptions.variableWidth
                    "
                    :vertical="normalizedOptions.slickOptions.vertical"
                    :waitForAnimate="
                        normalizedOptions.slickOptions.waitForAnimate
                    "
                >
                    <template
                        #prevArrow="arrowOption"
                        v-if="normalizedOptions.slickOptions.prevArrowHTML"
                    >
                        <div
                            v-html="
                                normalizedOptions.slickOptions.prevArrowHTML
                            "
                        ></div>
                    </template>
                    <template
                        #nextArrow="arrowOption"
                        v-if="normalizedOptions.slickOptions.nextArrowHTML"
                    >
                        <div
                            v-html="
                                normalizedOptions.slickOptions.nextArrowHTML
                            "
                        ></div>
                    </template>
                    <div v-for="item in listingClone.videos" :key="item.id">
                        <div class="position-relative">
                            <div
                                class="carousel-video-iframe"
                                v-html="renderIframe(item)"
                            ></div>
                        </div>
                        <div
                            v-if="
                                normalizedOptions.slickOptions.titles.video
                                    .show ||
                                normalizedOptions.slickOptions.titles.listing
                                    .show
                            "
                            class="video-titles"
                            :class="
                                normalizedOptions.slickOptions.titles.classes
                            "
                            :style="normalizedOptions.slickOptions.titles.style"
                        >
                            <div
                                v-if="
                                    normalizedOptions.slickOptions.titles
                                        .listing.show
                                "
                                class="listing-title"
                                :class="
                                    normalizedOptions.slickOptions.titles
                                        .listing.classes
                                "
                                :style="
                                    normalizedOptions.slickOptions.titles
                                        .listing.style
                                "
                            >
                                <div
                                    class="listing-title-inner"
                                    :style="
                                        normalizedOptions.slickOptions.titles
                                            .listing.inner.style
                                    "
                                    :class="
                                        normalizedOptions.slickOptions.titles
                                            .listing.inner.classes
                                    "
                                >
                                    {{ listingClone.name }}
                                </div>
                            </div>
                            <div
                                v-if="
                                    normalizedOptions.slickOptions.titles.video
                                        .show && renderVideoTitle(item)
                                "
                                class="video-title"
                                :class="
                                    normalizedOptions.slickOptions.titles.video
                                        .classes
                                "
                                :style="
                                    normalizedOptions.slickOptions.titles.video
                                        .style
                                "
                            >
                                <div
                                    class="video-title-inner"
                                    :style="
                                        normalizedOptions.slickOptions.titles
                                            .video.inner.style
                                    "
                                    :class="
                                        normalizedOptions.slickOptions.titles
                                            .video.inner.classes
                                    "
                                >
                                    {{ renderVideoTitle(item) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </VueSlickCarousel>
            </v-row>

            <v-row v-if="normalizedOptions.sliderType === 'slideGroup'">
                <v-slide-group
                    v-model="activeSlide"
                    :center-active="normalizedOptions.slideGroup.centerActive"
                    :active-class="normalizedOptions.slideGroup.activeClass"
                    :dark="normalizedOptions.slideGroup.dark"
                    :light="normalizedOptions.slideGroup.light"
                    :mandatory="normalizedOptions.slideGroup.mandatory"
                    :max="normalizedOptions.slideGroup.max"
                    :multiple="normalizedOptions.slideGroup.multiple"
                    :tag="normalizedOptions.slideGroup.tag"
                >
                    <v-slide-item
                        v-for="item in listingClone.videos"
                        :key="item.id"
                        :active-class="
                            normalizedOptions.slideGroup.sliderItemWrapper
                                .activeClass
                        "
                        :style="
                            normalizedOptions.slideGroup.sliderItemWrapper.style
                        "
                        :class="
                            normalizedOptions.slideGroup.sliderItemWrapper
                                .classes
                        "
                    >
                        <div class="slide-item-wrapper">
                            <div class="slide-item">
                                <div
                                    class="video-iframe"
                                    v-html="renderIframe(item)"
                                ></div>
                                <div
                                    v-if="
                                        normalizedOptions.slideGroup.titles
                                            .video.show ||
                                        normalizedOptions.slideGroup.titles
                                            .listing.show
                                    "
                                    class="video-titles"
                                    :class="
                                        normalizedOptions.slideGroup.titles
                                            .classes
                                    "
                                    :style="
                                        normalizedOptions.slideGroup.titles
                                            .style
                                    "
                                >
                                    <div
                                        v-if="
                                            normalizedOptions.slideGroup.titles
                                                .listing.show
                                        "
                                        class="listing-title"
                                        :class="
                                            normalizedOptions.slideGroup.titles
                                                .listing.classes
                                        "
                                        :style="
                                            normalizedOptions.slideGroup.titles
                                                .listing.style
                                        "
                                    >
                                        <div
                                            class="listing-title-inner"
                                            :style="
                                                normalizedOptions.slideGroup
                                                    .titles.listing.inner.style
                                            "
                                            :class="
                                                normalizedOptions.slideGroup
                                                    .titles.listing.inner
                                                    .classes
                                            "
                                        >
                                            {{ listingClone.name }}
                                        </div>
                                    </div>
                                    <div
                                        class="video-title"
                                        :class="
                                            normalizedOptions.slideGroup.titles
                                                .video.classes
                                        "
                                        v-if="
                                            normalizedOptions.slideGroup.titles
                                                .video.show &&
                                            renderVideoTitle(item)
                                        "
                                        :style="
                                            normalizedOptions.slideGroup.titles
                                                .video.style
                                        "
                                    >
                                        <div
                                            class="video-title-inner"
                                            :style="
                                                normalizedOptions.slideGroup
                                                    .titles.video.inner.style
                                            "
                                            :class="
                                                normalizedOptions.slideGroup
                                                    .titles.video.inner.classes
                                            "
                                        >
                                            {{ renderVideoTitle(item) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-slide-item>
                </v-slide-group>
                <v-container class="container-width">
                    <v-row>
                        <v-col cols="12">
                            <div
                                class="vd-flex slider-controls-container"
                                :style="
                                    normalizedOptions.slideGroup.sliderControls
                                        .container.style
                                "
                            >
                                <v-btn
                                    outlined
                                    large
                                    fab
                                    class="mr-auto"
                                    :color="
                                        normalizedOptions.slideGroup
                                            .sliderControls.previousButton
                                            .colour
                                    "
                                    @click="togglePrevious"
                                >
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-divider
                                    v-if="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.show
                                    "
                                    :dark="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.dark
                                    "
                                    :inset="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.inset
                                    "
                                    :light="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.light
                                    "
                                    :vertical="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.vertical
                                    "
                                    :class="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.classes
                                    "
                                    :style="
                                        normalizedOptions.slideGroup
                                            .sliderControls.divider.style
                                    "
                                >
                                </v-divider>
                                <v-btn
                                    outlined
                                    large
                                    fab
                                    :color="
                                        normalizedOptions.slideGroup
                                            .sliderControls.nextButton.colour
                                    "
                                    @click="toggleNext"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>

            <v-row
                v-if="normalizedOptions.sliderType === 'carousel'"
                class="carousel"
            >
                <v-col cols="12">
                    <v-carousel
                        v-model="activeSlide"
                        :active-class="normalizedOptions.carousel.activeClass"
                        :continuous="normalizedOptions.carousel.continuous"
                        :cycle="normalizedOptions.carousel.cycle"
                        :dark="normalizedOptions.carousel.dark"
                        :delimiter-icon="
                            normalizedOptions.carousel.delimiterIcon
                        "
                        :height="normalizedOptions.carousel.height"
                        :hide-delimiter-background="
                            normalizedOptions.carousel.hideDelimiterBackground
                        "
                        :hide-delimiters="
                            normalizedOptions.carousel.hideDelimiters
                        "
                        :interval="normalizedOptions.carousel.interval"
                        :light="normalizedOptions.carousel.light"
                        :mandatory="normalizedOptions.carousel.mandatory"
                        :max="normalizedOptions.carousel.max"
                        :multiple="normalizedOptions.carousel.multiple"
                        :next-icon="normalizedOptions.carousel.nextIcon"
                        :prev-icon="normalizedOptions.carousel.prevIcon"
                        :progress="normalizedOptions.carousel.progress"
                        :progress-color="
                            normalizedOptions.carousel.progressColor
                        "
                        :reverse="normalizedOptions.carousel.reverse"
                        :show-arrows="normalizedOptions.carousel.showArrows"
                        :show-arrows-on-hover="
                            normalizedOptions.carousel.showArrowsOnHover
                        "
                        :tag="normalizedOptions.carousel.tag"
                        :touchless="normalizedOptions.carousel.touchless"
                        :vertical="normalizedOptions.carousel.vertical"
                        :vertical-delimiters="
                            normalizedOptions.carousel.verticalDelimiters
                        "
                    >
                        <v-carousel-item
                            v-for="item in listingClone.videos"
                            :key="item.id"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                            :active-class="
                                normalizedOptions.carousel.sliderItem
                                    .activeClass
                            "
                        >
                            <div class="position-relative">
                                <div
                                    class="carousel-video-iframe"
                                    v-html="renderIframe(item)"
                                ></div>
                            </div>
                            <div
                                v-if="
                                    normalizedOptions.carousel.titles.video
                                        .show ||
                                    normalizedOptions.carousel.titles.listing
                                        .show
                                "
                                class="video-titles"
                                :class="
                                    normalizedOptions.carousel.titles.classes
                                "
                                :style="normalizedOptions.carousel.titles.style"
                            >
                                <div
                                    v-if="
                                        normalizedOptions.carousel.titles
                                            .listing.show
                                    "
                                    class="listing-title"
                                    :class="
                                        normalizedOptions.carousel.titles
                                            .listing.classes
                                    "
                                    :style="
                                        normalizedOptions.carousel.titles
                                            .listing.style
                                    "
                                >
                                    <div
                                        class="listing-title-inner"
                                        :style="
                                            normalizedOptions.carousel.titles
                                                .listing.inner.style
                                        "
                                        :class="
                                            normalizedOptions.carousel.titles
                                                .listing.inner.classes
                                        "
                                    >
                                        {{ listingClone.name }}
                                    </div>
                                </div>
                                <div
                                    v-if="
                                        normalizedOptions.carousel.titles.video
                                            .show && renderVideoTitle(item)
                                    "
                                    class="video-title"
                                    :class="
                                        normalizedOptions.carousel.titles.video
                                            .classes
                                    "
                                    :style="
                                        normalizedOptions.carousel.titles.video
                                            .style
                                    "
                                >
                                    <div
                                        class="video-title-inner"
                                        :style="
                                            normalizedOptions.carousel.titles
                                                .video.inner.style
                                        "
                                        :class="
                                            normalizedOptions.carousel.titles
                                                .video.inner.classes
                                        "
                                    >
                                        {{ renderVideoTitle(item) }}
                                    </div>
                                </div>
                            </div>
                        </v-carousel-item>
                    </v-carousel>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import {
    defineComponent,
    computed,
    onMounted,
    ref,
    toRef,
    nextTick,
    watch,
} from "@vue/composition-api";
import { cloneDeep, forEach, has, merge } from "lodash";
import VueSlickCarousel from "vue-slick-carousel";
import ListingService from "../services/ListingService";

export default defineComponent({
    name: "ListingVideos",
    components: {
        VueSlickCarousel,
    },
    props: {
        listing: {
            type: Object,
            default: () => ({}),
        },
        listingId: {
            type: Number,
            default: null,
        },
        listingSlug: {
            type: String,
            default: null,
        },
        settings: {
            type: Object,
        },
    },
    setup(props) {
        const loading = ref(false);
        const listingClone = toRef(props, "listing");
        const activeSlide = ref(0);
        const wrapperWidth = ref("830");
        const defaultSettings = ref({
            sliderType: "carousel",
            title: {
                show: true,
                text: "Virtual tour",
                style: "color: #000",
                classes: "color-primary",
            },
            intro: {
                show: true,
                textHtml:
                    "<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aspernatur assumenda, consequatur deserunt dicta distinctio exercitationem fugiat harum iste molestiae molestias nam obcaecati porro repudiandae sed veniam. Blanditiis perspiciatis soluta unde.</p>",
                classes: "",
                style: "",
            },
            slideGroup: {
                height: 500,
                activeClass: "v-slide-item--active",
                centerActive: true,
                dark: false,
                light: false,
                mandatory: false,
                max: undefined,
                multiple: false,
                tag: "div",
                style: "",
                classes: "",
                sliderItemWrapper: {
                    activeClass: "active",
                    style: "",
                    classes: "",
                },
                titles: {
                    style: "position: absolute; bottom: 0; left: 0;",
                    classes: "",
                    listing: {
                        show: true,
                        style: "",
                        classes: "",
                        inner: {
                            style: "",
                            classes: "",
                        },
                    },
                    video: {
                        show: true,
                        style: "",
                        classes: "",
                        inner: {
                            style: "",
                            classes: "",
                        },
                    },
                },
                sliderControls: {
                    show: true,
                    container: {
                        style: "margin-top: 20px;",
                    },
                    previousButton: {
                        colour: "primary",
                    },
                    divider: {
                        show: true,
                        dark: false,
                        inset: false,
                        light: false,
                        vertical: false,
                        style: "",
                        classes: "mt-8 mx-6",
                    },
                    nextButton: {
                        colour: "primary",
                    },
                },
            },
            carousel: {
                // Mirrors most of the v-carousel props, but with kebab case (https://vuetifyjs.com/en/api/v-carousel/#props)
                activeClass: "v-window-item--active",
                continuous: true,
                cycle: false,
                dark: false,
                delimiterIcon: "$delimiter",
                height: 500,
                hideDelimiterBackground: false,
                hideDelimiters: true,
                interval: 6000,
                light: false,
                mandatory: true,
                max: undefined,
                multiple: false,
                nextIcon: "$next",
                prevIcon: "$prev",
                progress: false,
                progressColor: undefined,
                reverse: false,
                showArrows: true,
                showArrowsOnHover: false,
                tag: "div",
                touchless: false,
                vertical: false,
                verticalDelimiters: undefined,
                titles: {
                    style: "position: absolute; bottom: 0; left: 0;",
                    classes: "",
                    listing: {
                        show: true,
                        style: "",
                        classes: "",
                        inner: {
                            style: "",
                            classes: "",
                        },
                    },
                    video: {
                        show: true,
                        style: "",
                        classes: "",
                        inner: {
                            style: "",
                            classes: "",
                        },
                    },
                },
                sliderItem: {
                    activeClass: "active",
                },
            },
            slickOptions: {
                accessibility: true,
                adaptiveHeight: false,
                arrows: true,
                asNavFor: null,
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: "50px",
                cssEase: "ease",
                dots: false,
                dotsClass: "slick-dots",
                draggable: true,
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: null,
                pauseOnDotsHover: false,
                pauseOnFocus: false,
                pauseOnHover: true,
                responsive: null,
                rows: 1,
                rtl: false,
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                waitForAnimate: true,
                prevArrowHTML: null,
                nextArrowHTML: null,
                titles: {
                    style: "position: absolute; bottom: 0; left: 0;",
                    classes: "",
                    listing: {
                        show: true,
                        style: "",
                        classes: "",
                        inner: {
                            style: "",
                            classes: "",
                        },
                    },
                    video: {
                        show: true,
                        style: "",
                        classes: "",
                        inner: {
                            style: "",
                            classes: "",
                        },
                    },
                },
            },
        });
        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        const renderPage = computed(() => {
            if (has(listingClone.value, "videos")) {
                if (listingClone.value.videos.length > 0) {
                    return true;
                }
            }
            return false;
        });

        function renderIframe(videoItem) {
            if (has(videoItem, "extraDetails.embedCode")) {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(
                    videoItem.extraDetails.embedCode,
                    "text/html"
                );
                let iframeElements = htmlDoc.getElementsByTagName("iframe");
                let iframeElement = iframeElements[0];
                iframeElement.id = "video-" + videoItem.id;
                if (normalizedOptions.value.sliderType == "carousel") {
                    iframeElement.style.width = "100%";
                    iframeElement.style.height =
                        normalizedOptions.value.carousel.height + "px";
                }
                return iframeElement.outerHTML;
            }
            return null;
        }

        function renderVideoTitle(videoItem) {
            let title = null;
            if (videoItem.caption) {
                title = videoItem.caption;
            } else if (has(videoItem, "extraDetails.title")) {
                title = videoItem.extraDetails.title;
            }
            return title;
        }

        function togglePrevious() {
            if (activeSlide.value == 0) {
                activeSlide.value = listingClone.value.videos.length - 1;
            } else {
                activeSlide.value = activeSlide.value - 1;
            }
        }

        function toggleNext() {
            if (activeSlide.value == listingClone.value.videos.length - 1) {
                activeSlide.value = 0;
            } else {
                activeSlide.value = activeSlide.value + 1;
            }
        }

        function getListingById(id) {
            ListingService.getListingFullDetailsById(id)
                .then((response) => {
                    if (has(response, "data.listing")) {
                        listingClone.value = response.data.listing;
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        function getListingBySlug(slug) {
            ListingService.getListingFullDetailsBySlug(slug)
                .then((response) => {
                    if (has(response, "data.listing")) {
                        listingClone.value = response.data.listing;
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    loading.value = false;
                });
        }

        function onResize() {
            const wrappers = document.querySelectorAll(
                ".widget-videos .slide-item-wrapper"
            );
            const activeWrapper = wrappers[activeSlide.value];
            const containerWrapper = document.querySelector(
                ".container.widget-videos .v-slide-group"
            );

            if (containerWrapper) {
                const containerWrapperWidth = containerWrapper.clientWidth;
                if (
                    containerWrapperWidth < activeWrapper.clientWidth ||
                    containerWrapperWidth < wrapperWidth.value
                ) {
                    wrappers.forEach((wrapper) => {
                        wrapper.style.width = containerWrapperWidth + "px";
                    });
                } else {
                    wrappers.forEach((wrapper) => {
                        wrapper.style.width = wrapperWidth.value + "px";
                    });
                }
            }
        }

        function init() {
            if (props.listingId) {
                getListingById(props.listingId);
            } else if (props.listingSlug) {
                getListingBySlug(props.listingSlug);
            }

            if (normalizedOptions.value.sliderType == "slideGroup") {
                window.addEventListener("resize", onResize, { passive: true });
            }

            loading.value = false;
        }

        onMounted(() => {
            init();
        });

        return {
            renderPage,
            normalizedOptions,
            listingClone,
            activeSlide,
            renderVideoTitle,
            renderIframe,
            togglePrevious,
            toggleNext,
        };
    },
});
</script>
<style>
.slide-item-wrapper {
    width: 830px;
    /*padding-left: 34px;*/
    padding-right: 34px;
}
.slide-item-wrapper .slide-item {
    position: relative;
}
.slide-item-wrapper .slide-item:hover > .video-titles {
    display: none;
}
.v-carousel:hover .video-titles {
    display: none;
}
.position-relative {
    position: relative;
}
.widget-videos .v-slide-group__prev {
    display: none;
}
.widget-videos .v-slide-group__next {
    display: none;
}

.video-iframe {
    overflow: hidden;
    /* 16:9 aspect ratio */
    padding-top: 56.25%;
    position: relative;
}

.video-iframe iframe {
    position: absolute;
    border: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.video-titles {
    position: absolute;
    bottom: 0;
    left: 0;
}
.listing-title {
    font-size: 19px;
    float: left;
    color: #fff;
    background-color: #000;
    padding: 16px;
}
.video-title {
    font-size: 19px;
    float: left;
    color: #000;
    background-color: #fff;
    padding: 16px;
}
</style>

